import { observer } from "mobx-react-lite";

import { FontIcon, Stack, TextBadge, TextBadgeColor } from "@bps/fluent-ui";
import {
  XeroFinancialSyncOperation,
  XeroFinancialSyncStatus
} from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { capitalizeSentence } from "@libs/utils/utils.ts";

interface XeroSyncHistoryItemBadgeProps {
  operation: XeroFinancialSyncOperation;
}

export const XeroSyncHistoryItemBadge = observer(
  ({ operation }: XeroSyncHistoryItemBadgeProps) => {
    let badgeColor: TextBadgeColor;

    switch (operation.status) {
      case XeroFinancialSyncStatus.Pending:
        badgeColor = TextBadgeColor.yellow;
        break;
      case XeroFinancialSyncStatus.InternalFailure:
      case XeroFinancialSyncStatus.Warnings:
      case XeroFinancialSyncStatus.Errors:
        badgeColor = TextBadgeColor.red;
        break;
      default:
        badgeColor = TextBadgeColor.green;
        break;
    }

    return (
      <TextBadge badgeColor={badgeColor}>
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
          {badgeColor === TextBadgeColor.red && (
            <FontIcon
              iconName="info"
              styles={{ root: { lineHeight: "14px" } }}
            />
          )}
          <div>{capitalizeSentence(operation.status)}</div>
        </Stack>
      </TextBadge>
    );
  }
);
